import React from 'react';
import { useEffect } from "react";
export function App() {
  useEffect(() => {
    // Facebook Pixel
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;

      // Wait for DOM to be ready
      const insertScript = () => {
        s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          // Retry once if script tag doesn't exist yet
          setTimeout(insertScript, 100);
        }
      };
      insertScript();
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    (window as any).fbq("init", "1292588308721525");
    (window as any).fbq("track", "PageView");

    // Hyros Pixel
    const hyrosScript = document.createElement("script");
    hyrosScript.type = "text/javascript";
    hyrosScript.src = "https://t.tryopal.com/v1/lst/universal-script?ph=c36b8366f49fbe16aa72cd07bfe77a19e20b712adad383e2a53674d1c721c50b&tag=!clicked&ref_url=" + encodeURIComponent(window.location.href);
    document.head.appendChild(hyrosScript);
  }, []);
  return <div className="flex flex-col w-full min-h-full bg-pink-50" data-id="element-0">
      {/* Header */}
      <header className="flex justify-center py-2 bg-white" data-id="element-1">
        <div className="text-pink-500 font-bold text-lg flex items-center" data-id="element-2">
          <span className="mr-1" data-id="element-3">The Beauty Journal</span>
          <span data-id="element-4">"Hot List"</span>
        </div>
      </header>
      {/* Main Content */}
      <main className="flex flex-col items-center max-w-2xl mx-auto px-4 pb-12" data-id="element-5">
        {/* Hero Image */}
        <div className="w-full my-4" data-id="element-6">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hfoW3s3CHjcMqgZU5vVmtr/Hero_Image.png" alt="Before and after moisturizer comparison" className="w-full" data-id="element-7" />
        </div>
        {/* Headline */}
        <div className="text-left w-full mb-4" data-id="element-8">
          <h6 className="text-sm mb-1" data-id="element-9">Dermatologist Reveals:</h6>
          <h1 className="font-bold text-xl leading-tight" data-id="element-10">
            These <span className="text-red-600" data-id="element-11">Top 5 Moisturizers</span> Give
            You That 'Just Had a Facial' Glow (Without the $200 Price Tag)
          </h1>
        </div>
        {/* Introduction */}
        <div className="text-left w-full text-sm mb-6 space-y-3" data-id="element-12">
          <p className="font-medium" data-id="element-13">
            (Los Angeles) That fresh, dewy glow you get after a professional
            facial - the kind that makes your skin look plump, radiant, and
            years younger - doesn't have to cost hundreds of dollars or require
            monthly appointments.
          </p>
          <p data-id="element-14">
            Whether it's that flat, tired look in harsh lighting, makeup that
            won't sit right on dry skin, or feeling like your complexion has
            lost its natural radiance, finding the right moisturizer that
            delivers true facial-level results can feel impossible.
          </p>
          <p data-id="element-15">
            As a leading skincare specialist, I've tested the most popular
            moisturizers to find what genuinely delivers that coveted
            post-facial glow - the kind of luminous, baby-soft skin that makes
            people ask what treatment you just had.
          </p>
          <p data-id="element-16">
            The #1 product took me completely by surprise, especially since it
            only has two ingredients. After doing more research though, I
            understand why both dermatologists and beauty influencers are
            rushing to get their hands on it for 2025.
          </p>
        </div>
        {/* Product Rankings */}
        {/* 5. Neutrogena */}
        <div className="w-full mb-6" data-id="element-17">
          <h3 className="text-lg font-bold mb-2" data-id="element-18">5. Neutrogena Hydro Boost</h3>
          <div className="bg-blue-100 p-4 mb-4 flex justify-center" data-id="element-19">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/juyNJx8YRYuQmQiYkFCvcM/Neutrogena.jpg" alt="Neutrogena Hydro Boost" className="h-48 object-contain" data-id="element-20" />
          </div>
          <p className="text-sm" data-id="element-21">
            A drugstore favorite that delivers impressive hydration with
            hyaluronic acid. While it provides good moisture, it doesn't quite
            achieve that coveted "facial glow" effect. Good for daily use, but
            don't expect transformative results.
          </p>
        </div>
        {/* 4. CeraVe */}
        <div className="w-full mb-6" data-id="element-22">
          <h3 className="text-lg font-bold mb-2" data-id="element-23">
            4. CeraVe Daily Moisturizing Lotion
          </h3>
          <div className="bg-blue-50 p-4 mb-4 flex justify-center" data-id="element-24">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jqB27TzYm1VBXNYug7jgWk/CeraVe.webp" alt="CeraVe Daily Moisturizing Lotion" className="h-48 object-contain" data-id="element-25" />
          </div>
          <p className="text-sm" data-id="element-26">
            Dermatologist-recommended for its ceramides and hyaluronic acid
            formula. While it's excellent for maintaining skin health, it
            focuses more on basic hydration than achieving that luminous,
            post-facial effect.
          </p>
        </div>
        {/* 3. Olay */}
        <div className="w-full mb-6" data-id="element-27">
          <h3 className="text-lg font-bold mb-2" data-id="element-28">3. Olay Regenerist</h3>
          <div className="bg-yellow-100 p-4 mb-4 flex justify-center" data-id="element-29">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/b75rKBjS3wrJ64BjgWV63M/Olay.webp" alt="Olay Regenerist" className="h-48 object-contain" data-id="element-30" />
          </div>
          <p className="text-sm" data-id="element-31">
            A peptide-rich formula that offers both hydration and anti-aging
            benefits. Shows good results in terms of skin plumpness, but takes
            several weeks to see the full effect. Some users report it feels
            heavy on the skin.
          </p>
        </div>
        {/* 2. La Mer */}
        <div className="w-full mb-6" data-id="element-32">
          <h3 className="text-lg font-bold mb-2" data-id="element-33">
            2. La Mer Moisturizing Cream
          </h3>
          <div className="bg-gray-100 p-4 mb-4 flex justify-center" data-id="element-34">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/t7Nu55YHbV4GQdfZFZF8Lz/La_Mer.jpg" alt="La Mer Moisturizing Cream" className="h-48 object-contain" data-id="element-35" />
          </div>
          <p className="text-sm" data-id="element-36">
            Luxury skincare at its finest, with the iconic Miracle Broth™.
            Delivers remarkable results but at an astronomical price point.
            While it does create that coveted glow, the cost makes it
            impractical for most consumers.
          </p>
        </div>
        {/* Who Took the #1 Spot? */}
        <div className="w-full mb-6" data-id="element-37">
          <h2 className="font-bold text-lg mb-4" data-id="element-38">Who Took the #1 Spot?</h2>
          <p className="text-sm mb-4" data-id="element-39">
            See why skincare experts consider this the #1 moisturizer for women
            seeking that post-facial glow; and learn how you can get your hands
            on this formula that{' '}
            <span className="font-bold bg-yellow-200" data-id="element-40">
              delivers radiant, baby-soft skin faster and more naturally than
              the competition
            </span>
            . Oh and as a bonus, it only has two ingredients and costs a
            fraction of the price.
          </p>
          <div className="flex justify-center my-4" data-id="element-41">
            <a href="https://tryopal.com/products/sacred" className="bg-pink-500 text-white font-bold py-2 px-12 rounded-md text-lg" data-id="element-42">
              Learn More &gt;&gt;
            </a>
          </div>
        </div>
        {/* Testimonials */}
        <div className="w-full mb-6" data-id="element-43">
          <h2 className="text-center text-xl font-bold text-purple-700 mb-4" data-id="element-44">
            Real People. Real Results.
          </h2>
          {/* Testimonial 1 */}
          <div className="flex mb-4" data-id="element-45">
            <div className="mr-2 flex-shrink-0" data-id="element-46">
              <div className="w-8 h-8 bg-pink-200 rounded-full overflow-hidden" data-id="element-47">
                <img src="https://randomuser.me/api/portraits/women/65.jpg" alt="User avatar" className="w-full h-full object-cover" data-id="element-48" />
              </div>
            </div>
            <div className="flex-grow" data-id="element-49">
              <p className="font-bold text-sm" data-id="element-50">Patricia Morgan</p>
              <p className="text-sm" data-id="element-51">
                "I'm in shock... my skin literally GLOWS now and people keep
                asking what facial I got!"
              </p>
              <div className="flex items-center text-xs mt-1" data-id="element-52">
                <button className="text-blue-600 mr-2" data-id="element-53">Like</button>
                <span className="mr-2" data-id="element-54">·</span>
                <button className="text-blue-600 mr-2" data-id="element-55">Reply</button>
                <span className="mr-2" data-id="element-56">·</span>
                <span className="text-gray-500" data-id="element-57">11 min</span>
                <span className="ml-auto flex items-center" data-id="element-58">
                  <span className="mr-1" data-id="element-59">247</span>
                  <span className="text-blue-600" data-id="element-60">👍</span>
                </span>
              </div>
            </div>
          </div>
          {/* Testimonial 2 */}
          <div className="flex mb-4" data-id="element-61">
            <div className="mr-2 flex-shrink-0" data-id="element-62">
              <div className="w-8 h-8 bg-pink-200 rounded-full overflow-hidden" data-id="element-63">
                <img src="https://randomuser.me/api/portraits/women/22.jpg" alt="User avatar" className="w-full h-full object-cover" data-id="element-64" />
              </div>
            </div>
            <div className="flex-grow" data-id="element-65">
              <p className="font-bold text-sm" data-id="element-66">Pamela Taylor</p>
              <p className="text-sm" data-id="element-67">
                "Started seeing that dewy glow in just 3 days. My makeup goes on
                like silk now. This stuff is magic."
              </p>
              <div className="flex items-center text-xs mt-1" data-id="element-68">
                <button className="text-blue-600 mr-2" data-id="element-69">Like</button>
                <span className="mr-2" data-id="element-70">·</span>
                <button className="text-blue-600 mr-2" data-id="element-71">Reply</button>
                <span className="mr-2" data-id="element-72">·</span>
                <span className="text-gray-500" data-id="element-73">34 min</span>
                <span className="ml-auto flex items-center" data-id="element-74">
                  <span className="mr-1" data-id="element-75">123</span>
                  <span className="text-blue-600" data-id="element-76">👍</span>
                </span>
              </div>
            </div>
          </div>
          {/* Testimonial 3 */}
          <div className="flex mb-4" data-id="element-77">
            <div className="mr-2 flex-shrink-0" data-id="element-78">
              <div className="w-8 h-8 bg-pink-200 rounded-full overflow-hidden" data-id="element-79">
                <img src="https://randomuser.me/api/portraits/women/33.jpg" alt="User avatar" className="w-full h-full object-cover" data-id="element-80" />
              </div>
            </div>
            <div className="flex-grow" data-id="element-81">
              <p className="font-bold text-sm" data-id="element-82">Rachel Thompson</p>
              <p className="text-sm" data-id="element-83">
                "Where did you get this? I need to try it! My skin looks so dull
                lately..."
              </p>
              <div className="flex items-center text-xs mt-1" data-id="element-84">
                <button className="text-blue-600 mr-2" data-id="element-85">Like</button>
                <span className="mr-2" data-id="element-86">·</span>
                <button className="text-blue-600 mr-2" data-id="element-87">Reply</button>
                <span className="mr-2" data-id="element-88">·</span>
                <span className="text-gray-500" data-id="element-89">14 min</span>
                <span className="ml-auto flex items-center" data-id="element-90">
                  <span className="mr-1" data-id="element-91">67</span>
                  <span className="text-blue-600" data-id="element-92">👍</span>
                </span>
              </div>
            </div>
          </div>
          {/* Testimonial 4 */}
          <div className="flex mb-4" data-id="element-93">
            <div className="mr-2 flex-shrink-0" data-id="element-94">
              <div className="w-8 h-8 bg-blue-200 rounded-full overflow-hidden" data-id="element-95">
                <img src="https://randomuser.me/api/portraits/men/45.jpg" alt="User avatar" className="w-full h-full object-cover" data-id="element-96" />
              </div>
            </div>
            <div className="flex-grow" data-id="element-97">
              <p className="font-bold text-sm" data-id="element-98">James Mitchell</p>
              <p className="text-sm" data-id="element-99">
                "Is this safe for sensitive skin? My wife breaks out from
                everything..."
              </p>
              <div className="flex items-center text-xs mt-1" data-id="element-100">
                <button className="text-blue-600 mr-2" data-id="element-101">Like</button>
                <span className="mr-2" data-id="element-102">·</span>
                <button className="text-blue-600 mr-2" data-id="element-103">Reply</button>
                <span className="mr-2" data-id="element-104">·</span>
                <span className="text-gray-500" data-id="element-105">16 min</span>
                <span className="ml-auto flex items-center" data-id="element-106">
                  <span className="mr-1" data-id="element-107">35</span>
                  <span className="text-blue-600" data-id="element-108">👍</span>
                </span>
              </div>
            </div>
          </div>
          {/* Testimonial 5 */}
          <div className="flex mb-4" data-id="element-109">
            <div className="mr-2 flex-shrink-0" data-id="element-110">
              <div className="w-8 h-8 bg-pink-200 rounded-full overflow-hidden" data-id="element-111">
                <img src="https://randomuser.me/api/portraits/women/42.jpg" alt="User avatar" className="w-full h-full object-cover" data-id="element-112" />
              </div>
            </div>
            <div className="flex-grow" data-id="element-113">
              <p className="font-bold text-sm" data-id="element-114">Jennifer Wilson</p>
              <p className="text-sm" data-id="element-115">
                "My skin is super reactive and had zero issues. The glow is
                incredible and it smells like vanilla!"
              </p>
              <div className="flex items-center text-xs mt-1" data-id="element-116">
                <button className="text-blue-600 mr-2" data-id="element-117">Like</button>
                <span className="mr-2" data-id="element-118">·</span>
                <button className="text-blue-600 mr-2" data-id="element-119">Reply</button>
                <span className="mr-2" data-id="element-120">·</span>
                <span className="text-gray-500" data-id="element-121">16 min</span>
                <span className="ml-auto flex items-center" data-id="element-122">
                  <span className="mr-1" data-id="element-123">54</span>
                  <span className="text-blue-600" data-id="element-124">👍</span>
                </span>
              </div>
            </div>
          </div>
          {/* Testimonial 6 */}
          <div className="flex mb-4" data-id="element-125">
            <div className="mr-2 flex-shrink-0" data-id="element-126">
              <div className="w-8 h-8 bg-pink-200 rounded-full overflow-hidden" data-id="element-127">
                <img src="https://randomuser.me/api/portraits/women/55.jpg" alt="User avatar" className="w-full h-full object-cover" data-id="element-128" />
              </div>
            </div>
            <div className="flex-grow" data-id="element-129">
              <p className="font-bold text-sm" data-id="element-130">Lauren Thompson</p>
              <p className="text-sm" data-id="element-131">
                "Better than my $300 facials honestly. Wish I had taken before
                photos because the difference is insane."
              </p>
              <div className="flex items-center text-xs mt-1" data-id="element-132">
                <button className="text-blue-600 mr-2" data-id="element-133">Like</button>
                <span className="mr-2" data-id="element-134">·</span>
                <button className="text-blue-600 mr-2" data-id="element-135">Reply</button>
                <span className="mr-2" data-id="element-136">·</span>
                <span className="text-gray-500" data-id="element-137">16 min</span>
                <span className="ml-auto flex items-center" data-id="element-138">
                  <span className="mr-1" data-id="element-139">89</span>
                  <span className="text-blue-600" data-id="element-140">👍</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* Final CTA */}
        <div className="flex justify-center my-6" data-id="element-141">
          <a href="https://tryopal.com/products/sacred" className="bg-red-600 text-white font-bold py-2 px-12 rounded-md text-lg" data-id="element-142">
            Learn More &gt;&gt;
          </a>
        </div>
        {/* Footer */}
        <div className="w-full mt-8 pt-8 border-t border-gray-300 text-xs text-gray-500" data-id="element-143">
          <div className="flex justify-center space-x-4 mb-4" data-id="element-144">
            <a href="https://tryopal.com/policies/terms-of-service" className="hover:text-gray-700" data-id="element-145">
              Terms of Service
            </a>
            <span data-id="element-146">·</span>
            <a href="https://tryopal.com/policies/privacy-policy" className="hover:text-gray-700" data-id="element-147">
              Privacy Policy
            </a>
            <span data-id="element-148">·</span>
            <a href="https://tryopal.com/pages/contact" className="hover:text-gray-700" data-id="element-149">
              Contact Us
            </a>
          </div>
          <p className="uppercase mb-2" data-id="element-150">
            This is an advertorial and not an actual article.
          </p>
          <p className="mb-4" data-id="element-151">
            The products mentioned are subject to availability. Results may
            vary. These statements have not been evaluated by the FDA. This
            product is not intended to diagnose, treat, cure, or prevent any
            disease.
          </p>
        </div>
      </main>
    </div>;
}